import { render, staticRenderFns } from "./image-item-web.vue?vue&type=template&id=350a4838"
import script from "./image-item-web.vue?vue&type=script&lang=ts"
export * from "./image-item-web.vue?vue&type=script&lang=ts"
import style0 from "./image-item-web.vue?vue&type=style&index=0&id=350a4838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports